var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 21",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0L24.1913 20.25H0.808657L12.5 0Z",
    fill: "#2B4B8E"
  })));
};
export default __webpack_public_path__ + "static/media/TreadmillShape.3793d951.svg";
export { SvgComponent as ReactComponent };